/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useGetAuditLogsReportLazyQuery } from "~/generated/graphql";
import { showError, showSuccess } from "~/services/toast";
import { downloadFileFromUrl } from "~/utils";

export function useGetAuditLogsReport() {
  const [getAuditLogsReport, { data, loading, error }] =
    useGetAuditLogsReportLazyQuery({
      fetchPolicy: "network-only",
      onError: (err) => {
        showError(err.message);
      },
      onCompleted: (result) => {
        showSuccess("Downloading report...");
        if (result?.auditLogSearchReport?.url) {
          downloadFileFromUrl(result.auditLogSearchReport.url);
        }
      },
    });

  return {
    getAuditLogsReport,
    data,
    loading,
    error,
  } as const;
}
